import React from 'react';
import '../cfcDashboard/DashboardHeader.scss';

/**
 * TechnicalAndCommercialLoading Component
 * 
 * This component renders a placeholder loading state for the Technical and Commercial section.
 * It displays a styled div that represents the loading state.
 * 
 * @component
 * @memberof Components
 * 
 * @returns {JSX.Element} A loading placeholder for the Technical and Commercial section.
 */

const TechnicalAndCommercialLoading = () => {
    return (
        <>
            <div className="dashboard-header" style={{ backgroundColor: '#edeff2', width: '32.5vw', height: '12vh' }}>
            </div>
        </>
    )
};

export default TechnicalAndCommercialLoading;
